"use client";
import Intro from "@/components/intro";
import { INTRO_CONSTANTS } from "./constants";

const IntroComponent = () => {
  return <Intro {...INTRO_CONSTANTS} />;
};

export default IntroComponent;
